import { defineMessages } from 'react-intl';

export default defineMessages({
  downloadFullSizedImage: {
    id: 'Download full sized image',
    defaultMessage: 'Download full sized image',
  },
});
